module.exports = __webpack_public_path__ + "apple-icon-152x152.png?3f5b417198069615b1d9bf43b91f7ad4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-152x152.png
// module id = 130
// module chunks = 0